// `Text`: literal parts, variable references and generators. Shared by the step-action schema and `targeting/` locators.
import { z } from 'zod'

export const VAR_NAME = z.string().regex(/^[A-Za-z_]\w*$/)

export const GENERATOR_KIND = z.enum(['random', 'timestamp'])

export const TEXT_PART = z.union([
  z.object({ text: z.string() }).strict(),
  z.object({ var: VAR_NAME }).strict(),
  z.object({ generate: GENERATOR_KIND }).strict(),
])

// Canonical: adjacent text parts merged, no empty text part.
export const TEXT = z.array(TEXT_PART)

export type VarName = z.infer<typeof VAR_NAME>
export type GeneratorKind = z.infer<typeof GENERATOR_KIND>
export type TextPart = z.infer<typeof TEXT_PART>
export type Text = z.infer<typeof TEXT>
